import {
  activeShoppingShareItems,
  shoppingOfferExpired,
  shoppingOfferPriceBani,
  type ShoppingListItem,
} from "./shopping-list";

/** Public, local-only presentation; no authentication or database dependency. */
export const SHOPPING_SAVINGS_ENABLED = true;

export interface ShoppingSavingsSummary {
  savingsBani: number;
  knownRows: number;
  unknownRows: number;
  totalRows: number;
}

/** Potential catalogue discount, NOT measured purchases or a second deduction.
 * Uses the same offer units/quantity and integer-bani rounding as payment totals.
 * Missing/inconsistent pairs contribute 0, as requested by the owner on 20 Sep.
 * Keep coverage internally: 0 contribution is not proof of an undiscounted item.
 * Never reconstruct an old price or modify the shopping-list snapshot.
 */
export function calculateShoppingSavings(
  items: readonly ShoppingListItem[], today: string,
): ShoppingSavingsSummary {
  const eligible = new Set(activeShoppingShareItems(items, today));
  const result: ShoppingSavingsSummary = { savingsBani: 0, knownRows: 0, unknownRows: 0, totalRows: 0 };
  for (const item of items) {
    if (shoppingOfferExpired(item, today)) continue;
    result.totalRows += 1;
    const oldBani = shoppingOfferPriceBani(item.oldPriceMdl);
    const newBani = shoppingOfferPriceBani(item.newPriceMdl);
    const difference = oldBani !== null && newBani !== null ? oldBani - newBani : null;
    const rowBani = difference === null ? null : difference * item.quantity;
    if (!eligible.has(item) || difference === null || difference < 0 || rowBani === null ||
        !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99 ||
        !Number.isSafeInteger(rowBani) || !Number.isSafeInteger(result.savingsBani + rowBani)) {
      result.unknownRows += 1;
      continue;
    }
    result.savingsBani += rowBani;
    result.knownRows += 1;
  }
  return result;
}
